export default {
    url: '',
    template: '<reports-courseresults classifiers="vm.classifiers" employees="vm.employees" sites="vm.sites"/>',
    controller (classifiers, employees, sites) {
        this.classifiers = classifiers;
        this.employees = employees;
        this.sites = sites;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/courseresults/overview/index.js